var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var PostControllerCertificate = {
    /*****************************************************************************************************
        * Is using route "api/post/LearnerCertificate" and http method "POST" to call the back-end.
    
        * @param {LearnerCertificateUploadDto} data
        * @returns {LearnerCertificateDownloadDto}
    ******************************************************************************************************/
    PostLearnerCertificate: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/LearnerCertificate", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/LearnerCertificate/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {LearnerCertificateUploadDto} data
        * @returns {LearnerCertificateDownloadDto}
    ******************************************************************************************************/
    PatchLearnerCertificate: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/LearnerCertificate/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PostControllerCertificate.js.map